// Override Liquid SDK's unavailable-location alert text (including dynamic inserts)
const UNAVAILABLE_ALERT_SELECTOR = '.liquid-unavailable-location-alert';
const UNAVAILABLE_ALERT_COPY = `We're sorry, this product is not currently available for delivery to your address. Click <a href="/en-us/store-locator/">here</a> to find this product in a store near you.`;

function applyUnavailableAlertCopy(root = document) {
	const alert = root.querySelector(UNAVAILABLE_ALERT_SELECTOR);
	if (alert && !alert.dataset.rbCustomCopy) {
		alert.innerHTML = UNAVAILABLE_ALERT_COPY;
		alert.dataset.rbCustomCopy = 'true';
	}
}

let unavailableObserverStarted = false;
function startUnavailableAlertObserver() {
	if (unavailableObserverStarted) {
		return;
	}

	unavailableObserverStarted = true;
	applyUnavailableAlertCopy();

	const observer = new MutationObserver((mutations) => {
		mutations.forEach((mutation) => {
			mutation.addedNodes.forEach((node) => {
				if (node.nodeType !== 1) {
					return;
				}

				if (node.matches && node.matches(UNAVAILABLE_ALERT_SELECTOR)) {
					applyUnavailableAlertCopy(node);
					return;
				}

				if (node.querySelector && node.querySelector(UNAVAILABLE_ALERT_SELECTOR)) {
					applyUnavailableAlertCopy(node);
				}
			});
		});
	});

	observer.observe(document.body, {
		childList: true,
		subtree: true
	});
}

export default function reservebarPopup() {
	startUnavailableAlertObserver();
	document
		.querySelectorAll('.reservebar-popup-trigger')
		.forEach(function (trigger) {
			if (
				trigger.classList.contains(
					'reservebar-popup-trigger--click-assigned'
				)
			) {
				return;
			}
			trigger.addEventListener('click', function (event) {
				event.preventDefault();
				let liquidGroupingID =
					trigger.attributes['reservebar-liquid-id']?.value;
				generateSidebar(liquidGroupingID);
				liquidSDK.init({
					clientId: '81751648f545a97274df4e2782d01a70',
					includeMerchandise: false
				});
			});
			trigger.classList.add('reservebar-popup-trigger--click-assigned');
		});

	document
		.querySelector('.main-container')
		.addEventListener('click', function (event) {
			if (event.target.classList.contains('quiz-add-to-cart')) {
				event.preventDefault();
				let liquidGroupingID = event.target
					.closest('.reservebar-popup-trigger')
					.getAttribute('reservebar-liquid-id');
				generateSidebar(liquidGroupingID);
				liquidSDK.init({
					clientId: '81751648f545a97274df4e2782d01a70',
					includeMerchandise: false
				});
			}
		});

	import(
		'Assets/scss/modules/library-modules/reservebar-popup/reservebar-popup.scss'
	);
}
if (document.querySelector('.main-container')) {
	document
		.querySelector('.main-container')
		.addEventListener('click', function (event) {
			if (
				event.target.closest('.reservebar-popup-trigger')
			) {
				event.preventDefault();
				let liquidGroupingID = event.target
					.closest('.reservebar-popup-trigger')
					.getAttribute('reservebar-liquid-id');

				if (generateSidebar(liquidGroupingID)) {
					liquidSDK.init({
						clientId: '81751648f545a97274df4e2782d01a70',
						includeMerchandise: false
					});
				}
			}
		});
}
if (document.querySelector('body.page')) {
	document
		.querySelector('body.page')
		.addEventListener('click', function (event) {
			if (event.target.classList.contains('liquid-cart-atc')) {
				var group_id = document
					.querySelector('.reservebar-popup__content[liquid-id]')
					.getAttribute('liquid-id');
				var product_name = document
					.querySelector(
						'a.reservebar-popup-trigger[reservebar-liquid-id="' +
							group_id +
							'"]'
					)
					.closest('.post-type-filter-grid-v2__post-container')
					.querySelector(
						'.post-type-filter-grid-v2__post-title h3'
					).innerHTML;
				var product_price = document.querySelector(
					'.liquid-fulfillment-method-selector .selected .liquid-price'
				).innerHTML;
				var product_qty = document.querySelector(
					'.reservebar-popup__content .liquid-cart-qty-selector'
				).value;
				console.log(
					product_name + ' ' + product_price + ' ' + product_qty
				);
			}
		});
}

// Open a popup modal
function generatePopup(liquidGroupingID) {
	if (document.querySelectorAll('.reservebar-popup__container').length > 0) {
		return false;
	}
	const popup = document.createElement('div');
	popup.innerHTML = `
        <div class="reservebar-popup reservebar-popup__container" style="" >
            <div class="reservebar-popup__content">
                <div class="reservebar-popup__close"></div>
				<p class='sub_heading p-sizing'>Buy Now</p>
                <h4 class="reservebar-popup__title">Enter your shipping address to see pricing and availability:</h4>
                <div class="reservebar-popup__content" liquid-id=${liquidGroupingID}>
				
                <div liquid-address-typeahead></div>

				<div class='liquid-cmsg'>
					<p class="p-xxxs-sizing">All orders are fulfilled by ReserveBar, and an independent third party that facilitates orders with licensed retailers. Due to legal restrictions, our products are available to ship to: AZ, CA, CO, CT, DC, DE, FL, IA, IL, IN, KY, MD, ME, MI, MN, MO, MT, NC, ND, NE, NH, NJ, NM, NV, NY, OK, PA, RI, SC, SD, VA, WI, WV, WY, WA. If you are in another state, click here to find this product in a store near you.</p>
				</div>

				<div liquid-fulfillment-method-selector></div>
				<div class="liquidError_34iJe" liquid-error=""></div>
				<div class="rb-add-to-cart-ctas">
					<div liquid-qty-selector><select disabled class="liquid-cart-qty-selector"><option value="1">1</option></select></div>
					<div liquid-atc><button disabled class="liquid-cart-atc">Add to Cart</button></div>
				</div>
                </div>
            </div>
        </div>`;
	document.body.appendChild(popup);
	document.body.classList.add('lock-position');
	const reservebarClose = document.querySelector('.reservebar-popup__close');
	reservebarClose.addEventListener('click', function () {
		popup.remove();
		document.body.classList.remove('lock-position');
	});
	return true;
}

// Open a sidebar modal
function generateSidebar(liquidGroupingID) {
	if (document.querySelectorAll('.reservebar-sidebar').length > 0) {
		return false;
	}
	const sidebar = document.createElement('div');
	sidebar.className = 'reservebar-sidebar';
	sidebar.innerHTML = `
		<div class="reservebar-sidebar__overlay"></div>
		<div class="reservebar-sidebar__content" liquid-id="${liquidGroupingID}">
			<div class="reservebar-sidebar__close"></div>
			<p class='sub_heading p-sizing'>Buy Now</p>
			<h4 class="reservebar-sidebar__title">Enter your shipping address to see pricing and availability:</h4>

			<div liquid-address-typeahead></div>

			<div class='liquid-cmsg'>
				<p class="p-xxxs-sizing">All orders are fulfilled by ReserveBar, and an independent third party that facilitates orders with licensed retailers. Due to legal restrictions, our products are available to ship to: AZ, CA, CO, CT, DC, DE, FL, IA, IL, IN, KY, MD, ME, MI, MN, MO, MT, NC, ND, NE, NH, NJ, NM, NV, NY, OK, PA, RI, SC, SD, VA, WI, WV, WY, WA. If you are in another state, click here to find this product in a store near you.</p>    
			</div>

			<div liquid-fulfillment-method-selector></div>
			<div class="liquidError_34iJe" liquid-error=""></div>

			<div class="rb-add-to-cart-ctas">
				<div liquid-qty-selector>
					<select disabled class="liquid-cart-qty-selector"><option value="1">1</option></select>
				</div>
				<div liquid-atc>
					<button disabled class="liquid-cart-atc">Add to Cart</button>
				</div>
			</div>
		</div>
	`;

	document.body.appendChild(sidebar);
	document.body.classList.add('lock-position');

	// Close button and overlay
	sidebar.querySelector('.reservebar-sidebar__close').addEventListener('click', () => {
		sidebar.remove();
		document.body.classList.remove('lock-position');
	});
	sidebar.querySelector('.reservebar-sidebar__overlay').addEventListener('click', () => {
		sidebar.remove();
		document.body.classList.remove('lock-position');
	});

	return true;
}
